import { Component, h, JSX, Prop, Host, Element, Watch } from '@stencil/core';
import { RcmImageProp } from '../rcm-image/rcm-image.types';
import { StoryblokService, DomService } from '../../services';

@Component({
  tag: 'rcm-stage-small-message',
  styleUrl: 'rcm-stage-small-message.scss',
  shadow: true,
})
export class RcmStageSmallMessage {
  @Element() private element: HTMLElement;

  @Prop() public imageSrc!: string | RcmImageProp;

  @Prop() public headline!: string;

  @Prop({ mutable: true }) imageUrl: string;

  @Watch('imageSrc')
  public componentDidLoad() {
    this.imageUrl = StoryblokService.parseImageSrc(this.imageSrc, this.element);
  }

  public render(): JSX.Element {
    return (
      <Host>
        <div class="stage" style={DomService.getBackgroundOrNull(this.imageUrl)}>
          <div class="stage__shadow"></div>
          <rcm-container>
            <rcm-column class="stage__content" span={12}>
              <rcm-headline
                color="var(--colors-basic-white)"
                class="stage__content-headline"
                bold
                xl
                level={1}
                headline={this.headline}
              ></rcm-headline>
            </rcm-column>
          </rcm-container>
        </div>
      </Host>
    );
  }
}
